import React from "react";

const NoData = ({
  title = "No Data",
  desc = "Looks like you don't have any data to view. ",
  color = "primary",
  noImage = false,
}) => {
  const svgColor = () => {};

  return (
    <div className="w-full flex-1 flex flex-col gap-5 items-center justify-center ">
      <div className="flex justify-center items-center">
        {!noImage && (
          <svg
            width="172"
            height="136"
            viewBox="0 0 172 136"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M100.287 49.7525C89.7059 49.8154 78.961 49.3254 68.9105 46.549C58.86 43.7726 49.9711 38.534 41.8903 32.4159C36.5999 28.4335 31.7893 25.2676 24.9206 25.745C18.2047 26.0962 11.7809 28.5894 6.59987 32.8556C-2.13751 40.4686 -0.811749 54.539 2.6731 64.4385C7.92562 79.3505 23.9105 89.7023 37.4837 96.4485C53.1781 104.25 70.413 108.785 87.6983 111.386C102.85 113.672 122.307 115.343 135.426 105.494C147.484 96.4611 150.792 75.8078 147.837 61.8631C147.118 57.7444 144.914 54.028 141.638 51.4108C133.166 45.2551 120.539 49.3631 111.019 49.5767C107.547 49.652 103.898 49.74 100.287 49.7525Z"
              fill="#FF781F"
              fillOpacity="0.2"
            />
            <path
              d="M48.6953 1V6.40201"
              stroke="#FF781F"
              strokeWidth="0.85"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M45.9814 3.7002H51.4107"
              stroke="#FF781F"
              strokeWidth="0.85"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M151.7 108.676V114.078"
              stroke="#FF781F"
              strokeWidth="0.85"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M148.986 111.376H154.416"
              stroke="#FF781F"
              strokeWidth="0.85"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M7.67292 85.3471C8.3563 85.3471 8.91029 84.7959 8.91029 84.1159C8.91029 83.436 8.3563 82.8848 7.67292 82.8848C6.98954 82.8848 6.43555 83.436 6.43555 84.1159C6.43555 84.7959 6.98954 85.3471 7.67292 85.3471Z"
              fill="#FF781F"
            />
            <path
              d="M7.67285 83.3848C8.08247 83.3848 8.41016 83.7148 8.41016 84.1162C8.41 84.5175 8.08237 84.8467 7.67285 84.8467C7.26337 84.8466 6.93571 84.5175 6.93555 84.1162C6.93555 83.7148 7.26326 83.3848 7.67285 83.3848Z"
              stroke="#FF781F"
              strokeOpacity="0.5"
            />
            <path
              d="M113.026 6.31388C113.71 6.31388 114.264 5.76267 114.264 5.08272C114.264 4.40277 113.71 3.85156 113.026 3.85156C112.343 3.85156 111.789 4.40277 111.789 5.08272C111.789 5.76267 112.343 6.31388 113.026 6.31388Z"
              fill="#CFCFCF"
            />
            <path
              d="M113.026 4.35156C113.436 4.35156 113.764 4.68157 113.764 5.08301C113.764 5.48431 113.436 5.81348 113.026 5.81348C112.617 5.81344 112.289 5.48429 112.289 5.08301C112.289 4.68159 112.617 4.3516 113.026 4.35156Z"
              stroke="#FF781F"
              strokeOpacity="0.5"
            />
            <path
              d="M78.7349 135.811C104.327 135.811 125.073 134.528 125.073 132.946C125.073 131.364 104.327 130.082 78.7349 130.082C53.1429 130.082 32.3965 131.364 32.3965 132.946C32.3965 134.528 53.1429 135.811 78.7349 135.811Z"
              fill="#FF781F"
              fillOpacity="0.1"
            />
            <path
              d="M43.0404 15.6729H110.338C112.013 15.6729 113.618 16.3346 114.802 17.5126C115.986 18.6906 116.651 20.2883 116.651 21.9543V101.615C116.651 103.281 115.986 104.879 114.802 106.057C113.618 107.235 112.013 107.896 110.338 107.896H34.4166C32.7423 107.896 31.1365 107.235 29.9526 106.057C28.7686 104.879 28.1035 103.281 28.1035 101.615V30.6854L43.0404 15.6729Z"
              fill="#FFB98A"
              stroke="#FF781F"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M116.347 54.4912H46.9531V108.662H116.347V54.4912Z"
              fill="#D2D2D2"
            />
            <path
              d="M28.1035 30.6854H40.3384C41.0561 30.6821 41.7434 30.3961 42.2498 29.8899C42.7561 29.3837 43.0404 28.6986 43.0404 27.9844V15.6729L28.1035 30.6854Z"
              fill="#FE6601"
              stroke="#FF781F"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M116.006 37.1914H47.37C44.6993 37.1914 42.5342 39.3456 42.5342 42.003V56.6135C42.5342 59.2709 44.6993 61.4251 47.37 61.4251H116.006C118.677 61.4251 120.842 59.2709 120.842 56.6135V42.003C120.842 39.3456 118.677 37.1914 116.006 37.1914Z"
              fill="white"
              stroke="#FF781F"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M55.8676 53.5375C58.1966 53.5375 60.0847 51.6589 60.0847 49.3415C60.0847 47.0241 58.1966 45.1455 55.8676 45.1455C53.5385 45.1455 51.6504 47.0241 51.6504 49.3415C51.6504 51.6589 53.5385 53.5375 55.8676 53.5375Z"
              fill="#FF781F"
            />
            <path
              d="M69.1254 53.5375C71.4545 53.5375 73.3425 51.6589 73.3425 49.3415C73.3425 47.0241 71.4545 45.1455 69.1254 45.1455C66.7963 45.1455 64.9082 47.0241 64.9082 49.3415C64.9082 51.6589 66.7963 53.5375 69.1254 53.5375Z"
              fill="#FF781F"
            />
            <path
              d="M82.3705 53.5375C84.6996 53.5375 86.5877 51.6589 86.5877 49.3415C86.5877 47.0241 84.6996 45.1455 82.3705 45.1455C80.0414 45.1455 78.1533 47.0241 78.1533 49.3415C78.1533 51.6589 80.0414 53.5375 82.3705 53.5375Z"
              fill="#FF781F"
            />
            <path
              d="M116.006 64.0566H47.37C44.6993 64.0566 42.5342 66.2109 42.5342 68.8682V83.4788C42.5342 86.1361 44.6993 88.2903 47.37 88.2903H116.006C118.677 88.2903 120.842 86.1361 120.842 83.4788V68.8682C120.842 66.2109 118.677 64.0566 116.006 64.0566Z"
              fill="white"
              stroke="#FF781F"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M55.8676 80.4125C58.1966 80.4125 60.0847 78.5339 60.0847 76.2165C60.0847 73.8991 58.1966 72.0205 55.8676 72.0205C53.5385 72.0205 51.6504 73.8991 51.6504 76.2165C51.6504 78.5339 53.5385 80.4125 55.8676 80.4125Z"
              fill="#FF781F"
            />
            <path
              d="M69.1254 80.0853C71.4545 80.0853 73.3425 78.2067 73.3425 75.8893C73.3425 73.572 71.4545 71.6934 69.1254 71.6934C66.7963 71.6934 64.9082 73.572 64.9082 75.8893C64.9082 78.2067 66.7963 80.0853 69.1254 80.0853Z"
              fill="#FF781F"
            />
            <path
              d="M82.3705 80.4125C84.6996 80.4125 86.5877 78.5339 86.5877 76.2165C86.5877 73.8991 84.6996 72.0205 82.3705 72.0205C80.0414 72.0205 78.1533 73.8991 78.1533 76.2165C78.1533 78.5339 80.0414 80.4125 82.3705 80.4125Z"
              fill="#FF781F"
            />
            <path
              d="M116.006 90.9219H47.37C44.6993 90.9219 42.5342 93.0761 42.5342 95.7334V110.344C42.5342 113.001 44.6993 115.156 47.37 115.156H116.006C118.677 115.156 120.842 113.001 120.842 110.344V95.7334C120.842 93.0761 118.677 90.9219 116.006 90.9219Z"
              fill="white"
              stroke="#FF781F"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M55.8676 107.268C58.1966 107.268 60.0847 105.389 60.0847 103.072C60.0847 100.755 58.1966 98.876 55.8676 98.876C53.5385 98.876 51.6504 100.755 51.6504 103.072C51.6504 105.389 53.5385 107.268 55.8676 107.268Z"
              fill="#FF781F"
            />
            <path
              d="M69.1254 107.268C71.4545 107.268 73.3425 105.389 73.3425 103.072C73.3425 100.755 71.4545 98.876 69.1254 98.876C66.7963 98.876 64.9082 100.755 64.9082 103.072C64.9082 105.389 66.7963 107.268 69.1254 107.268Z"
              fill="#FF781F"
            />
            <path
              d="M82.3705 107.268C84.6996 107.268 86.5877 105.389 86.5877 103.072C86.5877 100.755 84.6996 98.876 82.3705 98.876C80.0414 98.876 78.1533 100.755 78.1533 103.072C78.1533 105.389 80.0414 107.268 82.3705 107.268Z"
              fill="#FF781F"
            />
            <path
              d="M122.218 67.7973C136.674 67.7973 148.392 56.1376 148.392 41.7546C148.392 27.3716 136.674 15.7119 122.218 15.7119C107.763 15.7119 96.0439 27.3716 96.0439 41.7546C96.0439 56.1376 107.763 67.7973 122.218 67.7973Z"
              fill="white"
              stroke="#FF781F"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M144.546 42.0059C144.546 29.5794 134.472 19.5059 122.046 19.5059"
              stroke="#FFB98A"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M140.805 60.6484L147.774 67.5831"
              stroke="#FF781F"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M146.995 64.2182L144.831 66.4703C143.857 67.4834 143.894 69.0898 144.912 70.0583L163.713 87.9411C164.732 88.9096 166.346 88.8734 167.319 87.8604L169.483 85.6083C170.456 84.5952 170.42 82.9888 169.402 82.0203L150.601 64.1375C149.582 63.169 147.968 63.2052 146.995 64.2182Z"
              fill="white"
              stroke="#FF781F"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        )}
      </div>
      <div>
        <div className="body-one font-medium text-center mb-1">{title}</div>{" "}
        <div className="body-two text-center">{desc}</div>
      </div>
    </div>
  );
};

export default NoData;
